"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetPasswordPage = void 0;
/* eslint-disable @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-floating-promises */
/* Package Imports */
var query_string_1 = __importDefault(require("query-string"));
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_router_1 = require("react-router");
var react_router_dom_1 = require("react-router-dom");
var react_toastify_1 = require("react-toastify");
/* Blast Imports */
var actions_1 = require("../../auth/state/actions");
var ResetPasswordForm_1 = __importDefault(require("../components/ResetPasswordForm"));
var YellowButton_1 = require("@app/components/controls/YellowButton");
var ContainerPanel_1 = require("@app/components/layout/ContainerPanel");
var SplitPage_1 = require("@app/components/layout/SplitPage");
var AuthApi = __importStar(require("@app/services/api/auth"));
var faspexUrlHelper_1 = require("@app/services/faspexUrlHelper");
/* Imported CSS */
require("./ResetPasswordPage.scss");
var initialState = {
    isValidToken: false
};
/**
 * Reset Password page component
 */
var ResetPasswordPage = /** @class */ (function (_super) {
    __extends(ResetPasswordPage, _super);
    function ResetPasswordPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = initialState;
        /* Component Lifecycle Methods - end */
        /* Component Methods - begin */
        _this.handleResetPasswordSubmit = function (password, confirmPassword) {
            _this.props.onResetPassword(_this.state.token, password, confirmPassword);
        };
        return _this;
    }
    /* Component Lifecycle Methods - begin */
    ResetPasswordPage.prototype.componentDidMount = function () {
        var _this = this;
        var params = query_string_1.default.parse(this.props.location.search);
        var url = params.url;
        if (!url) {
            // No faspex url was provided in query, redirect to login page
            this.setState({ redirectPath: '/login' });
        }
        else {
            // Parse context token from faspex url
            var context_1 = faspexUrlHelper_1.parseContextUrl(url.toString()).context;
            // Validate token
            AuthApi.validateResetPasswordToken(context_1).then(function (response) {
                _this.setState({ isValidToken: response.isValid, token: context_1 });
            }).catch(function () {
                _this.setState(__assign(__assign({}, _this.state), { token: context_1 }));
            });
        }
    };
    // TODO: switch to "componentDidUpdate"
    ResetPasswordPage.prototype.componentWillReceiveProps = function (nextProps) {
        var passwordResetError = nextProps.passwordResetError;
        if (passwordResetError) {
            react_toastify_1.toast.error(passwordResetError);
        }
    };
    /* Component Methods - end */
    ResetPasswordPage.prototype.render = function () {
        var _a = this.state, redirectPath = _a.redirectPath, isValidToken = _a.isValidToken, token = _a.token;
        if (redirectPath) {
            return react_1.default.createElement(react_router_1.Redirect, { to: redirectPath });
        }
        return (react_1.default.createElement(SplitPage_1.SplitPage, { title: "Reset Password" },
            react_1.default.createElement(ContainerPanel_1.ContainerPanel, { title: "Reset your password", isLoading: this.props.isResettingPassword || !token },
                !isValidToken &&
                    react_1.default.createElement("div", { className: "expired-message" },
                        react_1.default.createElement("p", null, "Your password reset link has already been used or has expired and is no longer valid."),
                        react_1.default.createElement("p", null, "Return to the login page to request another password reset link."),
                        react_1.default.createElement(react_router_dom_1.Link, { to: "/login" },
                            react_1.default.createElement(YellowButton_1.YellowButton, { type: "button", className: "button-large button-centered" }, "Return to Login"))),
                isValidToken && token &&
                    react_1.default.createElement(ResetPasswordForm_1.default, { onSubmit: this.handleResetPasswordSubmit }))));
    };
    return ResetPasswordPage;
}(react_1.Component));
exports.ResetPasswordPage = ResetPasswordPage;
var mapStateToProps = function (store) {
    return {
        isResettingPassword: store.auth.isResettingPassword,
        passwordResetError: store.auth.passwordResetError
    };
};
var mapDispatchToProps = {
    onResetPassword: actions_1.resetPassword
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(ResetPasswordPage);
